import {
    Arrow,
    Content,
    PopoverContentProps,
    PopoverTriggerProps,
    Portal,
    PopoverProps as RadixPopoverProps,
    Root,
    Trigger,
} from '@radix-ui/react-popover';
import { forwardRef } from 'react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface PopoverProps extends RadixPopoverProps {
    className?: string;
    trigger: React.ReactNode;
    triggerProps?: PopoverTriggerProps;
    contentProps?: PopoverContentProps;
    hasArrow?: boolean;
    variant?: 'light' | 'dark';
}

/**
 * see https://www.radix-ui.com/primitives/docs/components/popover for api
 */
const Popover = forwardRef<HTMLButtonElement, PopoverProps>(
    (
        {
            className = '',
            trigger,
            triggerProps = {},
            contentProps = {},
            children,
            hasArrow = false,
            variant = 'light',
            ...popoverProps
        },
        ref,
    ) => {
        return (
            <Root {...popoverProps}>
                <Trigger ref={ref} asChild {...triggerProps}>
                    {trigger}
                </Trigger>
                <Portal>
                    <Content
                        className={twMerge(
                            'shadow-dropdown z-10 rounded',
                            variant === 'light' ? 'text-black bg-white' : 'text-white bg-black',
                            className,
                        )}
                        sideOffset={4}
                        {...contentProps}
                    >
                        {children}
                        {hasArrow && (
                            <Arrow
                                data-testid="popover-arrow"
                                className={twMerge('fill-current', variant === 'dark' ? 'text-black' : 'text-white')}
                            />
                        )}
                    </Content>
                </Portal>
            </Root>
        );
    },
);

export default Popover;
Popover.displayName = 'Popover';
